export default __webpack_public_path__ + "static/media/nodejs.ca7d5097.svg";